// extracted by mini-css-extract-plugin
module.exports = {"search":"_10211","box":"_13843","icon":"_9511","text":"_15404","btn":"_5443"};